<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Labs</h2>
          <ul class="breadcrumb">
            <li class="col">
              <a routerLink="/">Home</a>
            </li>/
            <li class="col" class="active">
              <a href="javascript:void(0);">Labs</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="about-institute gallery-sec ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <h4 class="yellow-color fw-bold mb-2">Computer lab</h4>
        <blockquote class="blockquote-div">
          <p>Computer themselves, and software yet to be developed, will revolutionize the way we learn
          </p>
          <h6>- Steve Jobs</h6>
        </blockquote>
        <p>Innovation and technology have become a part and parcel of the day to day life today. At GHRCACS we make sure
          to provide you with amenities which are par excellence. Computer laboratory is a part of the same facility.
          Our state-of-the-art computer laboratory has a plethora of sections. And, each of it provides support to
          internet applications, design application and programming. Hence, you can be assured of being on the receiving
          end of knowledge with practical experience with us.</p>
        <h4 class="yellow-color my-2">Our Attributes :</h4>
        <ul class="list-before">
          <li><strong>Comprehensive assistance : </strong> Comprehensive assistance by the lab faculty and educators to
            assist you with any issues arising in the operation of equipment or software. They are well versed with
            their job and will be a helping hand as and when needed. </li>
          <li><strong>High Speed Internet : </strong> Our laboratory is coupled with high speed internet. You can be
            assured of seamless working with the same. </li>
          <li><strong>Latest Configuration: </strong> Our computers are associated with the latest configuration to aid
            you in better processing. This is not it. The software of the computer is upgraded from time to time. Thus,
            you will be able to take benefits of the latest with the laboratory.</li>
          <li><strong>Hands-on-Practical : </strong> We comprehend the need of hand-on-practical experience for our
            students. Hence, we have a good number of computers in our laboratory to suffice the need. </li>
        </ul>
        <p> Computer laboratory is for you to explore new depths of academic pursuits. Hence, utilize it with immense
          care. While technology never ceases to be the best friend, make sure you do not make it your enemy by misusing
          it. Do not let it be your worst nightmare. </p>
        <div class="demo-gallery pt-40 mt-4">
          <ul class="lightgallery row row-cols-md-3 row-cols-2">
            <li class="col-4" data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/labs/labs.webp"
              data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/labs/labs.webp">
              <a href="#">
                <img class="img-responsive" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/labs/labs.webp"
                  alt="Computer Lab | GHRCACS, PUNE">
                <div class="demo-gallery-poster">
                  <h6>Computer Lab</h6>
                  <div class="line"></div>
                  <i class="fa fa-search-plus"></i>
                </div>
              </a>
            </li>
            <li class="col-4" data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/labs/labs-1.webp"
              data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/labs/labs-1.webp">
              <a href="#">
                <img class="img-responsive" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/labs/labs-1.webp"
                  alt="Computer Lab | GHRCACS, PUNE">
                <div class="demo-gallery-poster">
                  <h6>Computer Lab</h6>
                  <i class="fa fa-search-plus"></i>
                </div>
              </a>
            </li>
            <li class="col-4" data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/labs/labs-2.webp"
              data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/labs/labs-2.webp">
              <a href="#">
                <img class="img-responsive" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/labs/labs-2.webp"
                  alt="Computer Lab | GHRCACS, PUNE">
                <div class="demo-gallery-poster">
                  <h6>Computer Lab</h6>
                  <i class="fa fa-search-plus"></i>
                </div>
              </a>
            </li>
            <li class="col-4" data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/labs/labs-3.webp"
              data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/labs/labs-3.webp">
              <a href="#">
                <img class="img-responsive" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/labs/labs-3.webp"
                  alt="Computer Lab | GHRCACS, PUNE">
                <div class="demo-gallery-poster">
                  <h6>Computer Lab</h6>
                  <i class="fa fa-search-plus"></i>
                </div>
              </a>
            </li>
            <li class="col-4" data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/labs/labs-4.webp"
              data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/labs/labs-4.webp">
              <a href="#">
                <img class="img-responsive" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/labs/labs-4.webp"
                  alt="Computer Lab | GHRCACS, PUNE">
                <div class="demo-gallery-poster">
                  <h6>Computer Lab</h6>
                  <i class="fa fa-search-plus"></i>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
